import PublicPricingPage from './PublicPricingPage';
export default PublicPricingPage;